import { useState } from 'react';
import { APP_NAME } from '@/lib/brand';
import api from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { toast } from 'sonner';

export default function GuidedDemoForm({ origin = 'landing_principal', title = 'Solicita tu visita guiada', className = '' }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email || !form.message) {
      toast.error('Completa nombre, teléfono, email y mensaje');
      return;
    }
    setLoading(true);
    try {
      await api.post('/public/guided-demo-lead', { ...form, origin });
      setOpen(true);
      setForm({ name: '', phone: '', email: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo enviar tu solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={submit} className={`space-y-3 ${className}`} data-testid={`guided-demo-form-${origin}`}>
        <p className="text-sm font-semibold text-slate-100" data-testid={`guided-demo-title-${origin}`}>{title}</p>
        <div className="grid md:grid-cols-2 gap-2">
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-200">Nombre</Label>
            <Input data-testid={`guided-demo-name-${origin}`} value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} placeholder="Tu nombre" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-200">Teléfono</Label>
            <Input data-testid={`guided-demo-phone-${origin}`} value={form.phone} onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))} placeholder="+52..." />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs text-slate-200">Email</Label>
          <Input type="email" data-testid={`guided-demo-email-${origin}`} value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} placeholder="tu@email.com" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs text-slate-200">Mensaje</Label>
          <Textarea data-testid={`guided-demo-message-${origin}`} value={form.message} onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))} placeholder={`¿Qué te gustaría resolver con ${APP_NAME}?`} rows={3} />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid={`guided-demo-submit-${origin}`}>
          {loading ? 'Enviando...' : 'Solicitar visita guiada / demo'}
        </Button>
      </form>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`guided-demo-success-dialog-${origin}`}>
          <DialogHeader>
            <DialogTitle>¡Listo! Ya recibimos tu solicitud</DialogTitle>
            <DialogDescription>
              Un especialista te ayudará con tu visita guiada o demo sin costo.
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  );
}
